/*
  Free gifts bundle (snippets/product-free-gifts.liquid).
  1. On add to cart, tags the main product and its free gifts with a hidden
     `_free_gift_bundle` line item property, so the cart knows they belong together.
  2. In the cart page / cart drawer, removing one item of a bundle removes the whole bundle.
*/
(function () {
  const BUNDLE_PROPERTY = '_free_gift_bundle';
  // Sent on the gift lines only (never on the main product), so the discount flow can tell
  // which lines are free.
  const GIFT_PROPERTY = '__smart_discount_flow_properties';
  const GIFT_PROPERTY_VALUE = 'free';

  // Variant-based gifts: snippets/product-free-gifts.liquid renders one group per variant.
  // Show the group of the selected variant and mark only its gifts as selected, because
  // product-form (main.js) adds every `.product-info-upsell-*[data-selected="true"]` to the cart.
  function currentVariantId(container) {
    const scope = container.closest('product-info') || document;
    const input =
      scope.querySelector('form[data-type="add-to-cart-form"] [name="id"]') ||
      document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    if (input && input.value) return String(input.value);
    return new URLSearchParams(window.location.search).get('variant');
  }

  function syncFreeGifts() {
    document.querySelectorAll('[data-free-gifts]').forEach((container) => {
      const groups = Array.from(container.querySelectorAll('.free-gifts__group'));
      if (groups.length === 0) return;
      const variantId = currentVariantId(container);
      // No group for the selected variant means it has no gifts, so the block is hidden
      const active = groups.find((group) => group.dataset.variantId === variantId) || null;

      groups.forEach((group) => {
        const isActive = group === active;
        if (group.hidden === isActive) group.hidden = !isActive;
        group.querySelectorAll('.free-gifts__item[data-id]').forEach((item) => {
          item.dataset.selected = isActive ? 'true' : 'false';
        });
      });
      container.classList.toggle('free-gifts--empty', !active);
    });
  }

  let syncTimer;
  function scheduleSync() {
    clearTimeout(syncTimer);
    // The theme updates the variant id input after its own change handlers run
    syncTimer = setTimeout(syncFreeGifts, 60);
  }

  document.addEventListener('change', scheduleSync);
  document.addEventListener('click', scheduleSync);
  window.addEventListener('popstate', scheduleSync);
  // Sync right before the theme's submit handler collects the selected gifts
  document.addEventListener('submit', syncFreeGifts, true);
  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('form[data-type="add-to-cart-form"] [type="submit"], [name="add"]')) syncFreeGifts();
    },
    true
  );
  // Safety net for variant changes that don't fire a DOM event (e.g. sticky ATC pickers)
  setInterval(() => {
    if (document.querySelector('[data-free-gifts]')) syncFreeGifts();
  }, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFreeGifts);
  } else {
    syncFreeGifts();
  }

  // product-form (main.js) builds the request with `new FormData(form)`, which fires this event.
  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;

    syncFreeGifts();
    // Only the gifts of the selected variant's group (see syncFreeGifts below)
    const giftIds = Array.from(
      document.querySelectorAll('.free-gifts__item[data-id][data-selected="true"]')
    ).map((gift) => gift.dataset.id);
    const mainInput = form.querySelector('[name="id"]');
    if (giftIds.length === 0 || !mainInput) return;

    const mainId = String(mainInput.value);
    const items = [];
    for (const [name, value] of event.formData.entries()) {
      const match = name.match(/^items\[(\d+)\]\[id\]$/);
      if (match) items.push({ index: match[1], id: String(value) });
    }
    if (!items.some((item) => giftIds.includes(item.id))) return;

    items.forEach((item) => {
      if (item.id !== mainId && !giftIds.includes(item.id)) return;
      event.formData.append(`items[${item.index}][properties][${BUNDLE_PROPERTY}]`, mainId);
      if (item.id !== mainId) {
        event.formData.append(`items[${item.index}][properties][${GIFT_PROPERTY}]`, GIFT_PROPERTY_VALUE);
      }
    });
  });

  let removing = false;

  // Capture phase, so this runs before cart-remove-button's own click handler.
  document.addEventListener(
    'click',
    (event) => {
      const removeButton = event.target.closest('cart-remove-button[data-free-gift-bundle]');
      if (!removeButton) return;

      const cartItems = removeButton.closest('cart-items, cart-drawer-items');
      if (!cartItems) return;

      const bundleButtons = Array.from(
        cartItems.querySelectorAll('cart-remove-button[data-free-gift-bundle]')
      )
        .filter((button) => button.dataset.freeGiftBundle === removeButton.dataset.freeGiftBundle)
        .sort((a, b) => parseInt(a.dataset.index) - parseInt(b.dataset.index));
      if (bundleButtons.length < 2) return;

      event.preventDefault();
      event.stopPropagation();
      if (removing) return;
      removing = true;

      // Lines after the first one are removed silently, so the first line keeps its index
      // and can be removed through the theme's own updateQuantity, which re-renders the cart.
      const firstLine = parseInt(bundleButtons[0].dataset.index);
      const updates = {};
      bundleButtons.slice(1).forEach((button) => {
        updates[button.dataset.key] = 0;
      });

      cartItems.enableLoading(firstLine);
      fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
          return cartItems.updateQuantity(firstLine, 0);
        })
        .catch((error) => {
          console.error(error);
          cartItems.disableLoading(firstLine);
        })
        .finally(() => {
          removing = false;
        });
    },
    true
  );
})();
